const COLUMNS_GROUPS = [
  {
    id: "vendorName",
    label: "Vendor Name",
    widget: "text",
    width: 220
  },
  {
    id: "profileName",
    label: "Profile Name",
    widget: "text",
    width: 220
  },
  {
    id: "frequency",
    label: "Frequency",
    widget: "text",
    width: 140
  },
  {
    id: "lastBillDate",
    label: "Last Bill Date",
    widget: "date",
    width: 160
  },
  {
    id: "nextBillDate",
    label: "Next Bill Date",
    widget: "date",
    width: 160
  },
  {
    id: "status",
    label: "Status",
    widget: "status",
    width: 140
  },
  {
    id: "amount",
    label: "Amount",
    widget: "number",
    width: 140
  }
];

const ROW_DATA = [
  {
    vendorName: "Airtel Business",
    profileName: "Office Internet Subscription",
    frequency: "Monthly",
    lastBillDate: "2025-01-10",
    nextBillDate: "2025-02-10",
    status: "Active",
    amount: 1899
  },
  {
    vendorName: "ABC Power Services",
    profileName: "Electricity Bill",
    frequency: "Monthly",
    lastBillDate: "2025-01-05",
    nextBillDate: "2025-02-05",
    status: "Active",
    amount: 4200
  },
  {
    vendorName: "CleanPro Services",
    profileName: "Office Cleaning Contract",
    frequency: "Weekly",
    lastBillDate: "2025-01-28",
    nextBillDate: "2025-02-04",
    status: "Paused",
    amount: 3000
  }];

export {COLUMNS_GROUPS,ROW_DATA};